import styled from "styled-components";

export const StyledLogin = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    
    .login{
        background: #FFFFFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        padding: 50px 30px;
        text-align: center;
        width: 420px;

        p{
            font-size: 18px;
            line-height: 25px;
            color: #999999;
            margin-top: 20px;
        }

        .login-form{
            label{
                display: block;
                font-size: 12px;
                line-height: 16px;
                color: #838383;
                text-align: left;
                margin-top: 25px;
                margin-bottom: 5px;
            }

                input{
                    background: #EBEBEB;
                    border-radius: 8px;
                    width: 100%;
                    padding: 14px 20px;
                    font-size: 16px;
                    line-height: 22px;
                    letter-spacing: 0.06em;
                    border: none;
                    outline: none;
                    &::placeholder{
                        color: #838383;
                    }
                } 
                
                button{
                    background: rgba(187, 6, 0, 0.05);
                    border: 2px solid #BB0600;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 20px;
                    line-height: 27px;
                    color: #BB0600;
                    padding: 10px 80px;
                    cursor: pointer;
                    display: inline-block;
                    margin-top: 40px;
                    margin-bottom: 30px;
                }
            }
            a{
                font-size: 20px;
                line-height: 27px;
                text-decoration-line: underline;
                color: #838383;
            }
        @media (max-width: 576px) {
            box-shadow:none ;
            padding: 15px;
            width: initial;

            .login-form{
                input{
                    padding: 12px 15px;
                    font-size: 14px;
                }
            }
            a{
                font-size: 16px;
                line-height: 22px;
            }
        }
    }
    
`